<template>
  <v-container class="pa-0">
    <v-form ref="form">
      <v-app-bar color="transparent" class="elevation-0 pa-0 page-header-toolbar">
        <page-header-title :title="$t('changelog.title')"></page-header-title>
      </v-app-bar>

      <v-container grid-list-md>
        <v-card>
          <v-card-text class="pa-4">
            <v-layout row wrap>
              <v-flex xs12>
                <pre>{{ content }}</pre>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "Changelog",

  data() {
    return {
      content: null
    }
  },

  created() {
    this.content = require('!raw-loader!@/assets/changelog.md').default

    if(this.$hasNewVersionChangeLog()) {
      this.$updateSettingDB("changelog_hash", this.$getHashChangeLog())
      this.$store.dispatch("master/setChangeLogNewVersion", false)
    }
  },

  methods: {}
}
</script>

<style scoped></style>
